// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-tag a{display:inline-flex;color:#fff;border:1px solid #d7d7d7;line-height:24px;padding:0 6px;border-radius:2px}.asset-tag a:hover{color:#f4f4f4;border-color:#d8d8d8}.asset-tag .tag-actived{background:#2d8cf0;border-color:#2b85e4}", ""]);
// Exports
module.exports = exports;
